<template>
    <div>
        <CommonPopupFrame :changeHeight="500" :change-height-unit="'px'" :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
            <div style="height:20px;">
                <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
            </div>
            <div style="flex:1; display: flex; overflow:hidden;" @touchmove.stop="() => {}">
                <ModalFindMercenary :selectDong="{}" :region_result="region_result" :mode="MODAL_MODE.CURRENT_LOC" :is-show-tab="false" btn-name="초대하기" :btn-action="completeAction" />
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
    import CommonPopupFrame from "../modal/my/CommonPopupFrame";
    import ModalFindMercenary from "./ModalFindMercenary";
    import {MODAL_MODE} from "../../Constants";

    export default {
        name: "ModalFindMercenaryPopup",
        components: {ModalFindMercenary, CommonPopupFrame},
        props : {
            region_result : {
                type : Object,
                default : () => {}
            },
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                MODAL_MODE : MODAL_MODE,
                isOpen : false,
            }
        },
        methods : {
            closeAction(){
                if(this.isOpen) {
                    this.isOpen = false;
                    return;
                }
                setTimeout(() => {
                    this.$GlobalStore.closeLastModal();
                }, 300)
            },
            ActBeforeClose(){
                this.isOpen = false;
            }
        },
        mounted(){
            setTimeout(() => {
                this.isOpen = true;
            }, 100)
        },
        created(){
            //this.$GlobalStore.addModal('TestModal', {transitionName : '', isModalBackTransparent : true});
        }
    }
</script>

<style scoped>

</style>